<template>
    <div class="c-o-my-pages-header">
        <div class="c-o-my-pages-header__inner">
            <div class="c-o-my-pages-header__block">
                <h1 class="c-o-my-pages-header__title">Mina sidor</h1>
                <div v-if="isCompany && companyId && activeService" class="c-o-my-pages-header__details">
                    <ul class="c-o-my-pages-header__details-list">
                        <li class="c-o-my-pages-header__details-item">
                            <div class="c-o-my-pages-header__details-headline">Nuvarande abonnemang</div>
                            <div class="c-o-my-pages-header__details-description">{{getActiveServiceName}}, {{price}} kr</div>
                        </li>
                        <li class="c-o-my-pages-header__details-item">
                            <div class="c-o-my-pages-header__details-headline">Saldo</div>
                            <div class="c-o-my-pages-header__details-description">{{getBalance}} st återstår, justeras med {{getBalanceToAdd}} st den {{updateDate}}</div>
                        </li>
                        <li class="c-o-my-pages-header__details-item" v-if="getAdditionalServiceName">
                            <div class="c-o-my-pages-header__details-headline">Tillägg</div>
                            <div class="c-o-my-pages-header__details-description">
                                {{getAdditionalServiceName}}
                            </div>
                        </li>
                        <li class="c-o-my-pages-header__details-item">
                            <div class="c-o-my-pages-header__details-headline">Omdöme</div>
                            <div class="c-o-my-pages-header__details-description">
                                <rating :ratingValue="rating.Rating" :nrOfRatings="rating.NrOfRatings"></rating>
                            </div>
                        </li>
                    </ul>
                </div>
                <div v-if="isCompany && companyId" class="c-o-my-pages-header__button">
                    <atom-button icon="arrow_forward" label="Visa profilsida" :link="`/hantverkare/${companyId}/`"></atom-button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import filters from '../../../../filters/index.js';

    import AtomButton from '../../atoms/AtomButtonLink.vue';
    import Rating from '../../atoms/AtomRating.vue';

    export default{
        props: [
            'isCompany',
            'companyId',
            'activeService',
            'rating',
            'price',
            'additionalService'
        ],
        components: {
            AtomButton,
            Rating,
        },
        computed: {
            endDate: function(){
                return filters.formatDateWithMonth(this.activeService.EndDate);
            },
            updateDate: function(){
                return filters.formatDateWithMonth(this.activeService.ContactUpdateDate) || null;
            },
            getBalance: function(){
                return this.activeService.ContactBalance || null;
            },
            getActiveServiceName: function(){
                return this.activeService.Name || null;
            },
            getBalanceToAdd: function(){
                return this.activeService.BalanceToAdd || null;
            },
            getAdditionalServiceName: function(){
                return this.additionalService ? this.additionalService.Name : null;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/components/organisms/my-pages-sections/OrganismMyPagesHeader.vue